import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Styles from "./Welcome.module.scss";
import Logo from "../../assets/images/Lamynaals_Tech_Logo-01 5.png";
import WelcomeImg from "../../assets/images/Ellipse_Top.png"; // Placeholder or use something better

const Welcome = () => {
    const navigate = useNavigate();
    const userName = localStorage.getItem("userName") || "User";

    return (
        <Box className={Styles.container}>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className={Styles.content}
            >
                <Box className={Styles.logoSection}>
                    <img src={Logo} alt="Logo" className={Styles.logo} />
                </Box>

                <Box className={Styles.welcomeBox}>
                    <motion.div
                        initial={{ scale: 0.8, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ delay: 0.3, duration: 0.5 }}
                    >
                        <Typography variant="h2" className={Styles.title}>
                            Welcome, <span className={Styles.highlight}>{userName}</span>!
                        </Typography>
                    </motion.div>

                    <Typography className={Styles.subtitle}>
                        You have successfully connected to the Finance Module.
                    </Typography>

                    <Typography className={Styles.description}>
                        Manage your collections, accounts, and financial activities with ease.
                        Your dedicated dashboard is ready for you.
                    </Typography>

                    <motion.div
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <Button
                            variant="contained"
                            className={Styles.actionButton}
                            onClick={() => navigate("/data-add-screen")}
                        >
                            Open Data Add Screen
                        </Button>
                    </motion.div>
                </Box>
            </motion.div>

            <Box className={Styles.backgroundDecor}>
                <div className={Styles.circle1}></div>
                <div className={Styles.circle2}></div>
            </Box>
        </Box>
    );
};

export default Welcome;
